import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
    constructor(private translateService: TranslateService) {
        super(); this.getTranslations();
    }

    private getTranslations() {
        this.translateService.get([
            'Items per page',
            'Next page',
            'Previous page',
            'First page',
            'Last page'
        ]).subscribe(translations => {
            this.itemsPerPageLabel = translations['Items per page'] || 'Items per page';
            this.nextPageLabel = translations['Next page'] || 'Next page';
            this.previousPageLabel = translations['Previous page'] || 'Previous page';
            this.firstPageLabel = translations['First page'] || 'First page';
            this.lastPageLabel = translations['Last page'] || 'Last page';
            this.changes.next();
        });
    }
}
